module.exports = __webpack_public_path__ + "img/invest_bg.2fe3f6c7.png";